@if (isLoading) {
<div id="preloader">
  <div id="status">
    <div class="spinner"></div>
  </div>
</div>
}
<router-outlet></router-outlet>
